export type ReportBlockProps = { caseId: string; onCall: (number: "112" | "182") => void };

export function ReportBlock({ caseId, onCall }: ReportBlockProps) {
  const call = (number: "112" | "182") => {
    onCall(number);
    window.dispatchEvent(new CustomEvent("arabom:report-cta", { detail: { number } }));
  };
  return <section className="report" data-case-id={caseId}><h2>이 사람을 본 것 같다면</h2><p>지금 위치, 본 시각, 옷차림, 이동 방향을 알려 주세요.</p><div className="actions"><a href="tel:112" onClick={() => call("112")}>112에 전화하기</a><a href="tel:182" onClick={() => call("182")}>182에 상담하기</a></div><small>뒤따라가거나 붙잡지 마세요. 판단은 경찰이 해요.</small></section>;
}
